import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Paper
} from '@mui/material';
import {
  Security,
  People,
  School,
  MenuBook,
  Schedule,
  Category,
  LibraryBooks,
  CalendarToday,
  Settings,
  AdminPanelSettings,
  PersonAdd,
  History,
  Archive,
  Backup,
  Notifications
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Parametres = () => {
  const navigate = useNavigate();

  const menuItems = [
    { 
      title: 'Années', 
      icon: <CalendarToday sx={{ fontSize: 40, color: '#ef4444' }} />, 
      path: '/parametres/annees',
      description: 'Gérer les années universitaires'
    },
    { 
      title: 'Filières', 
      icon: <School sx={{ fontSize: 40, color: '#3b82f6' }} />, 
      path: '/parametres/filieres',
      description: 'Gérer les filières'
    },
    { 
      title: 'Niveaux', 
      icon: <MenuBook sx={{ fontSize: 40, color: '#8b5cf6' }} />, 
      path: '/parametres/niveaux',
      description: 'Gérer les niveaux'
    },
    { 
      title: 'Périodes', 
      icon: <Schedule sx={{ fontSize: 40, color: '#f59e0b' }} />, 
      path: '/parametres/periodes',
      description: 'Gérer les périodes'
    },
    { 
      title: 'Modules', 
      icon: <Category sx={{ fontSize: 40, color: '#10b981' }} />, 
      path: '/parametres/modules',
      description: 'Gérer les modules'
    },
    { 
      title: 'Matières', 
      icon: <LibraryBooks sx={{ fontSize: 40, color: '#06b6d4' }} />, 
      path: '/parametres/matieres',
      description: 'Gérer les matières'
    },
    { 
      title: 'Utilisateurs', 
      icon: <People sx={{ fontSize: 40, color: '#8b5cf6' }} />, 
      path: '/parametres/users',
      description: 'Gérer les utilisateurs'
    },
    { 
      title: 'Rôles', 
      icon: <Security sx={{ fontSize: 40, color: '#8b5cf6' }} />, 
      path: '/parametres/roles',
      description: 'Gérer les rôles et permissions'
    },
    { 
      title: 'Import Étudiants', 
      icon: <PersonAdd sx={{ fontSize: 40, color: '#10b981' }} />, 
      path: '/parametres/users/import-etudiants',
      description: 'Créer les comptes utilisateurs des étudiants'
    },
    { 
      title: 'Journal d\'audit', 
      icon: <History sx={{ fontSize: 40, color: '#8b5cf6' }} />, 
      path: '/parametres/audit-logs',
      description: 'Traçabilité des actions utilisateurs'
    },
    { 
      title: 'Archivage', 
      icon: <Archive sx={{ fontSize: 40, color: '#f97316' }} />, 
      path: '/parametres/archive',
      description: 'Archiver / restaurer les années'
    },
    { 
      title: 'Sauvegarde', 
      icon: <Backup sx={{ fontSize: 40, color: '#0ea5e9' }} />, 
      path: '/parametres/backup',
      description: 'Backup et restauration BDD'
    },
    { 
      title: 'Notifications', 
      icon: <Notifications sx={{ fontSize: 40, color: '#8b5cf6' }} />, 
      path: '/parametres/notifications',
      description: 'Préférences de notification'
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ color: '#1f2937' }}>
          ⚙️ Paramètres
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Gérez tous les paramètres de l'application
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {menuItems.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={item.path}>
            <Card
              sx={{
                borderRadius: 3,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.1)'
                }
              }}
              onClick={() => navigate(item.path)}
            >
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Box sx={{ mb: 2 }}>
                  {item.icon}
                </Box>
                <Typography variant="h6" fontWeight="600" sx={{ mb: 0.5 }}>
                  {item.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Parametres;

